module.exports = __webpack_public_path__ + "img/DasLetzteHochbett.bb8ee4ea.svg";